import { render } from "./AccountForm.vue?vue&type=template&id=e5f75334"
import script from "./AccountForm.vue?vue&type=script&lang=ts"
export * from "./AccountForm.vue?vue&type=script&lang=ts"
script.render = render

export default script